import React from "react";
import {Alert, Col, Row} from "reactstrap";
import AdvancedTable from "../../../../commonComponents/AdvancedTable";
import moment from "moment";
import MomentDisplay from "../../../../commonComponents/momentDisplay";
import ExpandedTransactionDetail from "./expandedTransactionDetail";


const STATUS_COLOR_MAPPING = {
    'S': 'bg-success',
    'F': 'bg-danger',
    'P': 'bg-info',
}
const STATUS_LABEL_MAPPING = {
    'S': 'Success',
    'F': 'Failed',
    'P': 'Pending',
}


export default function Transactions() {
    return (
        <>
            <Row>
                <Col>
                    <h3 className="page-header pb-2">Transaction List</h3>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col>
                    List paynamics transactions.
                    <Alert color="info" className="mt-2">
                        Transaction status may not be accurately retrieved. For official transaction status, please check with Paynamics.
                    </Alert>
                </Col>
            </Row>


            <AdvancedTable
                friendlyResourceName={"Transaction"}
                apiResourceName={"payment/transactions"}
                columnDefinition={[
                    {
                        name: "Request Transaction ID",
                        key: "request_id",
                        cell: row => (
                            <strong>{row.request_id}</strong>
                        ),
                        sortable: false,
                        // sortField: 'transaction_id',
                    },
                    {
                        name: "Payment For",
                        key: "payment_for",
                        cell: row => (
                            <span>{row.payment_for || "N/A"}</span>
                        ),
                        sortable: false,
                        sortField: 'payment_for',
                    },
                    {
                        name: "Amount",
                        key: "amount",
                        cell: row => (
                            <span className="text-end">
                                {new Intl.NumberFormat('en-PH', {
                                    style: 'currency',
                                    currency: 'PHP',
                                }).format(row.amount)}
                            </span>
                        ),
                        sortable: true,
                        sortField: 'amount',
                    },
                    {
                        name: "Status",
                        key: "status",
                        cell: row => {
                            return (
                                <span className={`badge ${STATUS_COLOR_MAPPING[row.status] || 'bg-secondary'}`}>
                                {STATUS_LABEL_MAPPING[row.status] || 'Unknown'}
                            </span>
                            )
                        },
                        sortable: true,
                        sortField: 'status',
                    },
                    {
                        name: "Date",
                        key: "created_at",
                        cell: row => (
                            <MomentDisplay
                                momentData={moment(row.created_at)}/>
                        ),
                        sortable: true,
                        sortField: 'created_at',
                    },
                ]}
                dataTableProps={{
                    expandableRows: true,
                    expandableRowsComponent: ExpandedTransactionDetail,
                }}
            />
        </>
    );
}